import { Model } from '@vuex-orm/core'
import Organization from '../organizations/model'
import EducationPlan from '../education-plan/model'

export const STATUS_APPROVED = 'APPROVED'
export const STATUS_DECLINED = 'DECLINED'
export const STATUS_IN_REVIEW = 'IN-REVIEW'

export const TYPE_SHARE = 'share'
export const TYPE_OWNER = 'owner'

export default class Share extends Model {
    static get entity () {
        return 'share'
    }

    static fields () {
        return {
            id: this.uid(),
            organizationId: this.uid(),
            educationPlanId: this.uid(),
            organization: this.belongsTo(Organization, 'organizationId'),
            educationPlans: this.hasMany(EducationPlan, 'educationPlanId'),
            type: this.attr(),
            status: this.attr(''),
            comment: this.attr(''),
        }
    }
}
